import axios from 'axios'
import getConfig from 'next/config'
import { v4 as uuidv4 } from 'uuid'

import parkings from '@/service/parkings'
import parkingsInternal from '@/service/parkingsInternal'
import subscriptions from '@/service/subscriptions'
import subscriptionsInternal from '@/service/subscriptionsInternal'
import paymentsInternal from '@/service/paymentsInternal'
import contact from '@/service/contact'
import newsletter from '@/service/newsletter'
import { Faq } from '@/service/faq'
import { FaqInternal } from '@/service/faqInternal'
import discounts from '@/service/discounts'
import logger from '@/service/logger'
import blockings from '@/service/blockings'

const {
  publicRuntimeConfig: { API_URL }
} = getConfig()

export const instance = axios.create({
  baseURL: API_URL
})

export const internalInstance = axios.create({
  baseURL: '/'
})

instance.interceptors.request.use(config => {
  config.headers['X-Trace-Id'] = uuidv4()
  return config
})

internalInstance.interceptors.request.use(config => {
  config.headers['X-Trace-Id'] = uuidv4()
  return config
})

const isLocalhost = () => {
  if (typeof window !== 'undefined') {
    return (
      window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1'
    )
  }
  return false
}

const getHttpClient = () => {
  return isLocalhost() ? instance : axios
}

const api = {
  parkings: parkings(getHttpClient()),
  parkingsInternal: parkingsInternal(getHttpClient()),
  subscriptions: subscriptions(getHttpClient()),
  subscriptionsInternal: subscriptionsInternal(getHttpClient()),
  paymentsInternal: paymentsInternal(getHttpClient()),
  contact: contact(getHttpClient()),
  newsletter: newsletter(getHttpClient()),
  faq: Faq(getHttpClient()),
  faqInternal: FaqInternal(getHttpClient()),
  discounts: discounts(getHttpClient()),
  logger: logger(getHttpClient()),
  blockings: blockings(getHttpClient())
}

export const apiSSR = {
  parkings: parkings(instance)
}

export default api
export * from '@/service/parkings'
export * from '@/service/parkingsInternal'
export * from '@/service/subscriptions'
export * from '@/service/subscriptionsInternal'
export * from '@/service/paymentsInternal'
export * from '@/service/contact'
export * from '@/service/newsletter'
export * from '@/service/faq'
export * from '@/service/faqInternal'
export * from '@/service/discounts'
export * from '@/service/logger'
export * from '@/service/blockings'
